import { AxiosRequestConfig } from 'axios';
import { emeraldRequest } from 'src/common/api/emerald-request';
import { EntryMethod } from 'src/common/enumerations/entry-method';
import { UnitOfMeasureTypes } from 'src/common/enumerations/unit-of-measure-type';
import { IItemLookup } from 'src/common/interfaces/dtos/IItemLookup';
import { EmeraldRequestParams } from 'src/common/interfaces/requests/EmeraldRequestParams';
import { store } from 'src/common/redux/configure-store';
import { IItemLookupCriteria } from 'src/items-list/business-logic/service/product-lookup';

export const priceQuery = async (
  itemCode: string,
  entryMethod?: EntryMethod,
): Promise<IItemLookup> => {
  const transactionId = store.getState().transaction.transactionId ?? '';
  const criteria: IItemLookupCriteria = {
    scanData: [{ data: itemCode }],
    transactionId,
    actionDescription: 'PriceQuery',
    quantity: {
      value: 1,
      units: 1,
      unitOfMeasureCode: UnitOfMeasureTypes.Each,
    },
    entryMethod,
  };

  const axiosConfig: AxiosRequestConfig = {
    url: `/items/price-query/${itemCode}`,
    method: 'POST',
    data: criteria,
  };

  const emeraldRequestParams: EmeraldRequestParams = {
    config: axiosConfig,
    addPOSMetaData: true,
    showLoadingComponent: true,
    showLoggingInfo: true,
  };
  const response = await emeraldRequest<IItemLookup>(emeraldRequestParams);
  return response;
};
